// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file route_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChangeRouteDriverOnShiftRequestSchema, CreateRouteFromPickupLocationGroupRequestSchema, CreateRoutesFromStopsRequestSchema, MoveJobsBetweenRoutesRequestSchema, PseudoRouteCreateRequestSchema, Route, RouteCancelRequestSchema, RouteCreateWithJobsRequestSchema, RouteForceCompleteRequestSchema, RouteIdRequestSchema, RouteJson, RouteListRequestSchema, RouteListSchema, RouteSchema, RouteUpdateWithJobsRequestSchema } from "./route_pb";
import { file_route } from "./route_pb";
import type { Truck, TruckJson } from "./truck_pb";
import { file_truck } from "./truck_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file route_service.proto.
 */
export const file_route_service: GenFile = /*@__PURE__*/
  fileDesc("ChNyb3V0ZV9zZXJ2aWNlLnByb3RvEglyYWNjb29uYWkiWgogQWN0aXZlVHJ1Y2tMaXN0V2l0aFJvdXRlc1JlcXVlc3QSNgoWb3duZXJfb3JnYW5pemF0aW9uX2lkcxgBIAMoBFIWb3duZXJfb3JnYW5pemF0aW9uX2lkcyJmChlBY3RpdmVUcnVja0xpc3RXaXRoUm91dGVzEkkKEnRydWNrc193aXRoX3JvdXRlcxgBIAMoCzIZLnJhY2Nvb25haS5UcnVja1dpdGhSb3V0ZVISdHJ1Y2tzX3dpdGhfcm91dGVzIlMKDlRydWNrV2l0aFJvdXRlEh8KBXRydWNrGAEgASgLMhAucmFjY29vbmFpLlRydWNrEiAKBnJvdXRlcxgCIAMoCzIQLnJhY2Nvb25haS5Sb3V0ZTLCCAoMUm91dGVTZXJ2aWNlElAKE0NyZWF0ZVJvdXRlV2l0aEpvYnMSJS5yYWNjb29uYWkuUm91dGVDcmVhdGVXaXRoSm9ic1JlcXVlc3QaEC5yYWNjb29uYWkuUm91dGUiABJuCiJDcmVhdGVSb3V0ZUZyb21QaWNrdXBMb2NhdGlvbkdyb3VwEjQucmFjY29vbmFpLkNyZWF0ZVJvdXRlRnJvbVBpY2t1cExvY2F0aW9uR3JvdXBSZXF1ZXN0GhAucmFjY29vbmFpLlJvdXRlIgASWAoVQ3JlYXRlUm91dGVzRnJvbVN0b3BzEicucmFjY29vbmFpLkNyZWF0ZVJvdXRlc0Zyb21TdG9wc1JlcXVlc3QaFC5yYWNjb29uYWkuUm91dGVMaXN0IgASTAoRQ3JlYXRlUHNldWRvUm91dGUSIy5yYWNjb29uYWkuUHNldWRvUm91dGVDcmVhdGVSZXF1ZXN0GhAucmFjY29vbmFpLlJvdXRlIgASUAoTVXBkYXRlUm91dGVXaXRoSm9icxIlLnJhY2Nvb25haS5Sb3V0ZVVwZGF0ZVdpdGhKb2JzUmVxdWVzdBoQLnJhY2Nvb25haS5Sb3V0ZSIAEk4KEkZvcmNlQ29tcGxldGVSb3V0ZRIkLnJhY2Nvb25haS5Sb3V0ZUZvcmNlQ29tcGxldGVSZXF1ZXN0GhAucmFjY29vbmFpLlJvdXRlIgASQAoLQ2FuY2VsUm91dGUSHS5yYWNjb29uYWkuUm91dGVDYW5jZWxSZXF1ZXN0GhAucmFjY29vbmFpLlJvdXRlIgASQQoKTGlzdFJvdXRlcxIbLnJhY2Nvb25haS5Sb3V0ZUxpc3RSZXF1ZXN0GhQucmFjY29vbmFpLlJvdXRlTGlzdCIAEjkKCEdldFJvdXRlEhkucmFjY29vbmFpLlJvdXRlSWRSZXF1ZXN0GhAucmFjY29vbmFpLlJvdXRlIgASPQoMQXBwcm92ZVJvdXRlEhkucmFjY29vbmFpLlJvdXRlSWRSZXF1ZXN0GhAucmFjY29vbmFpLlJvdXRlIgASWAoVTW92ZUpvYnNCZXR3ZWVuUm91dGVzEicucmFjY29vbmFpLk1vdmVKb2JzQmV0d2VlblJvdXRlc1JlcXVlc3QaFC5yYWNjb29uYWkuUm91dGVMaXN0IgASWgoYQ2hhbmdlUm91dGVEcml2ZXJPblNoaWZ0EioucmFjY29vbmFpLkNoYW5nZVJvdXRlRHJpdmVyT25TaGlmdFJlcXVlc3QaEC5yYWNjb29uYWkuUm91dGUiABJxChpMaXN0QWN0aXZlVHJ1Y2tzV2l0aFJvdXRlcxIrLnJhY2Nvb25haS5BY3RpdmVUcnVja0xpc3RXaXRoUm91dGVzUmVxdWVzdBokLnJhY2Nvb25haS5BY3RpdmVUcnVja0xpc3RXaXRoUm91dGVzIgBCBloELi9wYg", [file_route, file_truck]);

/**
 * @generated from message raccoonai.ActiveTruckListWithRoutesRequest
 */
export type ActiveTruckListWithRoutesRequest = Message<"raccoonai.ActiveTruckListWithRoutesRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.ActiveTruckListWithRoutesRequest
 */
export type ActiveTruckListWithRoutesRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.ActiveTruckListWithRoutesRequest.
 * Use `create(ActiveTruckListWithRoutesRequestSchema)` to create a new message.
 */
export const ActiveTruckListWithRoutesRequestSchema: GenMessage<ActiveTruckListWithRoutesRequest, {jsonType: ActiveTruckListWithRoutesRequestJson}> = /*@__PURE__*/
  messageDesc(file_route_service, 0);

/**
 * @generated from message raccoonai.ActiveTruckListWithRoutes
 */
export type ActiveTruckListWithRoutes = Message<"raccoonai.ActiveTruckListWithRoutes"> & {
  /**
   * @generated from field: repeated raccoonai.TruckWithRoute trucks_with_routes = 1 [json_name = "trucks_with_routes"];
   */
  trucksWithRoutes: TruckWithRoute[];
};

/**
 * @generated from message raccoonai.ActiveTruckListWithRoutes
 */
export type ActiveTruckListWithRoutesJson = {
  /**
   * @generated from field: repeated raccoonai.TruckWithRoute trucks_with_routes = 1 [json_name = "trucks_with_routes"];
   */
  trucks_with_routes?: TruckWithRouteJson[];
};

/**
 * Describes the message raccoonai.ActiveTruckListWithRoutes.
 * Use `create(ActiveTruckListWithRoutesSchema)` to create a new message.
 */
export const ActiveTruckListWithRoutesSchema: GenMessage<ActiveTruckListWithRoutes, {jsonType: ActiveTruckListWithRoutesJson}> = /*@__PURE__*/
  messageDesc(file_route_service, 1);

/**
 * @generated from message raccoonai.TruckWithRoute
 */
export type TruckWithRoute = Message<"raccoonai.TruckWithRoute"> & {
  /**
   * @generated from field: optional raccoonai.Truck truck = 1;
   */
  truck?: Truck;

  /**
   * @generated from field: repeated raccoonai.Route routes = 2;
   */
  routes: Route[];
};

/**
 * @generated from message raccoonai.TruckWithRoute
 */
export type TruckWithRouteJson = {
  /**
   * @generated from field: optional raccoonai.Truck truck = 1;
   */
  truck?: TruckJson;

  /**
   * @generated from field: repeated raccoonai.Route routes = 2;
   */
  routes?: RouteJson[];
};

/**
 * Describes the message raccoonai.TruckWithRoute.
 * Use `create(TruckWithRouteSchema)` to create a new message.
 */
export const TruckWithRouteSchema: GenMessage<TruckWithRoute, {jsonType: TruckWithRouteJson}> = /*@__PURE__*/
  messageDesc(file_route_service, 2);

/**
 * @generated from service raccoonai.RouteService
 */
export const RouteService: GenService<{
  /**
   * @generated from rpc raccoonai.RouteService.CreateRouteWithJobs
   */
  createRouteWithJobs: {
    methodKind: "unary";
    input: typeof RouteCreateWithJobsRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.CreateRouteFromPickupLocationGroup
   */
  createRouteFromPickupLocationGroup: {
    methodKind: "unary";
    input: typeof CreateRouteFromPickupLocationGroupRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.CreateRoutesFromStops
   */
  createRoutesFromStops: {
    methodKind: "unary";
    input: typeof CreateRoutesFromStopsRequestSchema;
    output: typeof RouteListSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.CreatePseudoRoute
   */
  createPseudoRoute: {
    methodKind: "unary";
    input: typeof PseudoRouteCreateRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.UpdateRouteWithJobs
   */
  updateRouteWithJobs: {
    methodKind: "unary";
    input: typeof RouteUpdateWithJobsRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.ForceCompleteRoute
   */
  forceCompleteRoute: {
    methodKind: "unary";
    input: typeof RouteForceCompleteRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.CancelRoute
   */
  cancelRoute: {
    methodKind: "unary";
    input: typeof RouteCancelRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.ListRoutes
   */
  listRoutes: {
    methodKind: "unary";
    input: typeof RouteListRequestSchema;
    output: typeof RouteListSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.GetRoute
   */
  getRoute: {
    methodKind: "unary";
    input: typeof RouteIdRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.ApproveRoute
   */
  approveRoute: {
    methodKind: "unary";
    input: typeof RouteIdRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.MoveJobsBetweenRoutes
   */
  moveJobsBetweenRoutes: {
    methodKind: "unary";
    input: typeof MoveJobsBetweenRoutesRequestSchema;
    output: typeof RouteListSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.ChangeRouteDriverOnShift
   */
  changeRouteDriverOnShift: {
    methodKind: "unary";
    input: typeof ChangeRouteDriverOnShiftRequestSchema;
    output: typeof RouteSchema;
  },
  /**
   * @generated from rpc raccoonai.RouteService.ListActiveTrucksWithRoutes
   */
  listActiveTrucksWithRoutes: {
    methodKind: "unary";
    input: typeof ActiveTruckListWithRoutesRequestSchema;
    output: typeof ActiveTruckListWithRoutesSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_route_service, 0);

